import React from 'react';
import { Checkbox } from '../../../components/common/Checkbox';
import Select from '../../../components/common/Select';
import { RadioGroup } from '../../../components/common/Radio';
import styles from './Playground.module.css';
import Input from '../../../components/common/Input';

const Control = ({ label, type = 'text', options, ...props }) => {
  return (
    <div className={styles.controlGroup}>
      {type === 'checkbox' ? (
        <Checkbox
          label={label}
          {...props}
        />
      ) : type === 'select' ? (
        <Select
          label={label}
          options={options}
          {...props}
        />
      ) : type === 'radio' ? (
        <RadioGroup
          label={label}
          options={options}
          {...props}
        />
      ) : (
        <label className={styles.controlLabel}>
          {label}
          <Input
            type={type}
            {...props}
          />
        </label>
      )}
    </div>
  );
};

const Playground = ({ controls, preview }) => {
  return (
    <section className={styles.playgroundSection}>
      <h2>Playground</h2>
      <div className={styles.playground}>
        <div className={styles.controls}>
          {controls}
        </div>
        <div className={styles.preview}>
          <div className={styles.previewTitle}>미리보기</div>
          <div className={styles.previewContent}>
            {preview}
          </div>
        </div>
      </div>
    </section>
  );
};

export { Playground, Control }; 